export default __webpack_public_path__ + "static/logo_256_oneFUSE-ef641e90098462b7189d7e6463f611a0.svg";